package top.wcpe.allincore.ui.runtime.ir.subscribe

import kotlin.jvm.JvmField

/**
 * 订阅句柄：可取消、可查询取消状态。
 */
interface Subscription {

    /** 取消订阅（幂等）。 */
    fun cancel()

    /** 是否已取消。 */
    fun isCancelled(): Boolean

    /**
     * 静默无操作的常量实现。
     */
    companion object {
        /** 静默无操作的常量实现。 */
        @JvmField
        val NOOP: Subscription = object : Subscription {
            override fun cancel() {
            }

            override fun isCancelled(): Boolean = true

            override fun toString(): String = "Subscription.NOOP"
        }
    }
}
